import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import { useContext } from "react"
import { GlobalContext } from './_app'

import Head from 'next/head'

import { Header } from "../fuselage/global/header/header"
import { Footer } from '../fuselage/theme/2024/layout/footer/footer'
import { HeaderShim } from '../fuselage/global/header/header'
import { PageHeader } from '../fuselage/theme/2027/blocks/page-header/page-header'
import { SpeakerGrid } from '../fuselage/layout/speaker-grid/speaker-grid'
import { SpeakerCard } from '../fuselage/components/speaker-card/speaker-card'
 
import handleSeomaticMeta from "../lib/seomatic"


function Speakers({ seomatic, craftCmsProfiles }) {

	const globals = useContext(GlobalContext)


	// console.log('cms profile data:', craftCmsProfiles)

	return (
		<div className='bg-default'>

			<Head>
				{ handleSeomaticMeta( seomatic ) } 
            </Head>

			<Header mainMenu={globals.nodes} />
			<HeaderShim />

			<PageHeader>
				<div className="formatted">
					<p className='fs-1 fw-600 lh-1 c-primary'>Advisory Board 2027</p>
					<p className="fs-6 fw-400 mt-sm">Our Advisory Board consists of key influencers in the African aviation industry.</p>
				</div>
            </PageHeader>

			<section className="block bg-default pt-0">
				<div className="container">

					<SpeakerGrid decal="gap-sm mt-md">
						{craftCmsProfiles.map( speaker => (
							<SpeakerCard 
								key={speaker.id}
								url={`/speakers/profile/${speaker.slug}`}
								profile={speaker.profile} 
								photoUrl={speaker.avatar[0] ? speaker.avatar[0].url : null}
								fullName={speaker.title}
								jobTitle={speaker.positions[0] && speaker.positions[0].jobTitle}
								company={speaker.positions[0] && speaker.positions[0].organisation}
							/>
						))}
					</SpeakerGrid>

				</div>
			</section>

			<Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>

		</div>
	)
}
Speakers.theme = 'aviadev-2024'

export async function getStaticProps() {

	// const cmsData = await craftApolloClient().query({
    //     query: gql`
	// 		query SEO {
	// 			entry(site: "${process.env.SITE_HANDLE}", id: "11552") {
	// 				title
	// 				seomatic (asArray: true) {
	// 					metaTitleContainer
	// 					metaTagContainer
	// 				}
	// 			}
	// 		}
    //     `
    // })


	const craftCmsProfiles = await craftApolloClient().query({
        query: gql`
            query Profiles {
                entries(site: "${process.env.SITE_HANDLE}", section: "profileGroups", id: "42540") {
					... on profileGroups_default_Entry {
						id
						title
						profiles {
							... on profiles_profile_Entry {
								id
								slug
								title
								avatar {
									... on avatars_Asset {
										id
										url
										width
										height
									}
								}
								positions {
									... on positions_BlockType {
										id
										jobTitle
										organisation
									}
								}
								profile
							}
						}
					}
				}
            }
          
        `
	})

	return {
		props: { 
			// seomatic: cmsData.data.entry.seomatic,
			craftCmsProfiles: craftCmsProfiles.data.entries[0].profiles
		}
	}
}

export default Speakers


